module.exports = __webpack_public_path__ + "static/media/mri.e3207be0.svg";